import { render, staticRenderFns } from "./LabelGenerationError.vue?vue&type=template&id=6336b250&scoped=true"
import script from "./LabelGenerationError.vue?vue&type=script&lang=js"
export * from "./LabelGenerationError.vue?vue&type=script&lang=js"
import style0 from "./LabelGenerationError.vue?vue&type=style&index=0&id=6336b250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336b250",
  null
  
)

export default component.exports